export default __webpack_public_path__ + "static/media/2018_Letten_et_al_2018_PNAS.e3754798.pdf";